import * as React from "react";
const SvgTimes = (props) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M24 8L8 24M8 8L24 24", stroke: "#262626", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgTimes;
